<template>
  <div class="cant_buy">
    <van-collapse v-model="activeNames">
      <van-collapse-item title="查看不可购买商品" name="1">
        <div class="cant_list">
          <cant-header @clearAllCant="clearAllCant" />
          <div v-for="(item, index) in getCartNoneList.list" :key="index">
            <cant-product
              @lookAsProduct="lookAsProduct"
              :item="item"
              @goProductDetail="goProductDetail"
            />
          </div>
        </div>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>
<script>
import CantHeader from "../CantHeader";
import CantProduct from "../CantProduct";
export default {
  components: {
    CantHeader,
    CantProduct
  },
  data() {
    return {
      activeNames: []
    };
  },
  computed: {
    getCartNoneList() {
      return this.$store.getters.getCartList.tCartArrayDTO[
        this.$store.getters.getCartList.tCartArrayDTO.length - 1
      ];
    }
  },
  methods: {
    clearAllCant() {
      this.$emit("clearAllCant");
      this.$toast("点击清空失效商品");
    },
    lookAsProduct() {
      this.$toast("点击查看类似");
    },
    goProductDetail(spuId) {
      this.$emit("goProductDetail", spuId);
    }
  }
};
</script>

<style lang="less" scoped>
.cant_buy {
  ::v-deep .van-cell {
    background: #f6f7f8;
    font-size: 12px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.87);
    line-height: 48px;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  ::v-deep .van-cell__title {
    flex: none;
  }
  ::v-deep .van-cell__right-icon {
    color: #000;
    font-weight: 600;
    font-size: 12px;
  }
  ::v-deep .van-collapse-item__content {
    padding: 0;
  }
  .cant_list {
    margin-bottom: 12px;
  }
}
</style>
